import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../../core/design-system/components/Button';
import './styles.css';

const Step1 = ({ onNext }) => {
  const { t } = useTranslation('wizard');

  return (
    <div className="wizard-step-container">
      <div className="wizard-content">
        <h1 className="wizard-title">{t('step1.title')}</h1>
        <p className="wizard-subtitle">{t('step1.subtitle')}</p>
      </div>
      <div className="wizard-actions">
        <Button 
          onClick={onNext} 
          className="btn-primary"
          fullWidth
        >
          {t('step1.button')}
        </Button>
      </div>
    </div>
  );
};

export default Step1; 